import keyMirror from "key-mirror-nested";

const FETCH_ACTIONS = {
    FETCH: null,
    FETCHED: null,
    FAILED_FETCH: null,
};
const CREATE_ACTIONS = {
    CREATE: null,
    CREATED: null,
    FAILED_CREATE: null,
};
const UPDATE_ACTIONS = {
    UPDATE: null,
    UPDATED: null,
    FAILED_UPDATE: null,
};

const DELETE_ACTIONS = {
    DELETE: null,
    DELETED: null,
    FAILED_DELETE: null,
};


const TEST_ACTIONS = {
    START: null,
    FINISH: null
};

const LENDER_ACTIONS = keyMirror({
    CREDIT_POLICY: {
        LIST: { 
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        ITEM: {
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        TEST: {
            ...TEST_ACTIONS
        }
    },
    DOCUMENT_POLICY: {
        LIST: { 
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        ITEM: {
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        TEST: {
            ...TEST_ACTIONS
        }
    },
    USERS: {
        LIST: { 
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        ITEM: {
            ...FETCH_ACTIONS, 
            ...CREATE_ACTIONS, 
            ...UPDATE_ACTIONS, 
            ...DELETE_ACTIONS 
        },
        TEST: {
            ...TEST_ACTIONS
        }
    }
});

export default LENDER_ACTIONS;